var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMediaQuery, useTheme } from '@mui/material';
import classes from 'classnames';
export var SideImageLayout = function (_a) {
    var header = _a.header, content = _a.content, nav = _a.nav, footer = _a.footer, imageLeft = _a.imageLeft, imageRight = _a.imageRight, leftPanel = _a.leftPanel, _b = _a.className, className = _b === void 0 ? '' : _b, _c = _a.classNames, classNames = _c === void 0 ? {} : _c, _d = _a.leftPanelWidth, leftPanelWidth = _d === void 0 ? '24rem' : _d;
    var theme = useTheme();
    var showImages = useMediaQuery(theme.breakpoints.up('md'));
    return (_jsxs("div", __assign({ className: classes('min-h-widget', className), style: {
            display: 'grid',
            gridTemplateColumns: "\n          ".concat(leftPanel && showImages ? "minmax(0, ".concat(leftPanelWidth, ")") : '', "\n          ").concat(imageLeft && showImages ? 'minmax(0, 24rem)' : '', "\n          ").concat(content ? 'auto' : '', "\n          ").concat(imageRight && showImages ? 'minmax(0, 24rem)' : '', "\n        "),
        } }, { children: [leftPanel && showImages && (_jsx("div", __assign({ className: classes('', classNames.imageLeft) }, { children: leftPanel }))), imageLeft && showImages && (_jsx("div", { className: classes('', classNames.imageLeft), style: {
                    backgroundImage: "url(".concat(imageLeft, ")"),
                    backgroundSize: 'cover',
                    backgroundPosition: '50% 20%',
                    backgroundRepeat: 'no-repeat',
                } })), content && (_jsxs("div", __assign({ className: classes('min-h-widget h-full place-items-center', classNames.content), style: {
                    display: 'grid',
                    gridTemplateRows: "\n              ".concat(header ? 'auto' : '', "\n              ").concat(content ? '1fr' : '', "\n              ").concat(nav ? 'auto' : '', "\n              ").concat(footer ? 'auto' : '', "\n            "),
                } }, { children: [header && header, content, nav && nav, footer && footer] }))), imageRight && showImages && (_jsx("div", { className: classes('', classNames.imageRight), style: {
                    backgroundImage: "url(".concat(imageRight, ")"),
                    backgroundSize: 'cover',
                    backgroundPosition: '50% 20%',
                    backgroundRepeat: 'no-repeat',
                } }))] })));
};
